import { Component} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppContractBlockBankProductsRequestComponent } from '../contract-block-bank-products-request-form/contract-block-bank-products-request-form';

@Component({
    selector: 'app-contract-block-bank-products',
    templateUrl: './contract-block-bank-products.component.html',
    styleUrl: './contract-block-bank-products.component.scss',
 
})
export class AppContractProductsBlockComponent {
  public bankProductsMap = new Map([
    ['CREDIT',{icon:'bank-fill'}],
    ['GUARANTEE',{icon:'shield-star-fill'}],
    ['FACTORING',{icon:'file-search-fill'}],
    ['LEASING',{icon:'file-chart-2-fill'}],
  ])
  public hideBlock:boolean = false
  constructor(
    private dialog:MatDialog
  ){}
  requestProduct(product:string) {
    let ref = this.dialog.open(AppContractBlockBankProductsRequestComponent)
    ref.componentInstance.product = product
  }
}